import { useEffect } from "react";
import { api } from "@/lib/api";
import { buildQuestionsOrAnswers, buildWinners, buildCombined } from "@/lib/reportImages";

/* Headless render target. The backend (Playwright/Chromium) navigates here to
   produce the EXACT same PNGs as the admin download buttons, then emails them.
   Not linked in the UI. Requires ?token=<reports|admin JWT>. */
export default function ReportRender() {
  useEffect(() => {
    const run = async () => {
      try {
        const q = new URLSearchParams(window.location.search);
        const mode = q.get("mode") || "questions";
        // Auth is injected at the browser level (Playwright set_extra_http_headers),
        // so same-origin API calls carry the Authorization header automatically.
        let images = [];
        if (mode === "winners") {
          const start = q.get("start");
          const end = q.get("end") || start;
          const r = await api.get(`/admin/top-winners?start=${start}&end=${end}&limit=6`);
          images = await buildWinners({ ...r.data, start, end });
        } else if (mode === "combined") {
          const date = q.get("date");
          const [wr, ar] = await Promise.all([
            api.get(`/admin/top-winners?date=${date}&limit=6`),
            api.get(`/admin/answers?date=${date}`),
          ]);
          images = await buildCombined({ ...wr.data, date }, ar.data);
        } else {
          const date = q.get("date");
          const r = await api.get(`/admin/answers?date=${date}`);
          images = await buildQuestionsOrAnswers(mode, r.data);
        }
        window.__REPORT_IMAGES__ = images;
        window.__REPORT_DONE__ = true;
      } catch (e) {
        window.__REPORT_ERROR__ = String((e && e.message) || e);
        window.__REPORT_DONE__ = true;
      }
    };
    run();
  }, []);

  return <div data-testid="report-render-root" style={{ padding: 12, fontFamily: "monospace" }}>report-render</div>;
}
